import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Card, Tabs, Tab, Spinner, Badge, Modal, Carousel, Image, Button, Form, NavDropdown, Navbar, Nav, Container } from 'react-bootstrap'




import { Link, Navigate, useNavigate } from "react-router-dom";

import { FaHeart, FaTruck, FaFacebookMessenger, FaSketch, FaRegHeart, FaRegCommentAlt, FaRegEye, FaRegEyeSlash, FaMicrochip } from "react-icons/fa";
import { BsStarFill, BsStarHalf, BsStar, BsEye, BsBookmark, BsTerminal, BsCpu, BsAirplane, BsRobot, BsChatSquareHeart, BsFiletypePdf, BsClock } from "react-icons/bs";
import { MdSignalCellular1Bar, MdSignalCellular3Bar, MdSignalCellular4Bar } from "react-icons/md";


// import "../../components/CardArticleForm.css";
// import "../../../shared/styles/CardsLayout.css";
import "../../../shared/styles/UtillitiesComponent.css"

import Test_Card_01 from '../../../assets/Test_Card_01.png';
import Test_Card_02 from '../../../assets/Test_Card_02.png';


function NewestArticle() {



    /* var user = auth.currentUser;
   
    var uid = "";

    if (user != null) {
       
        uid = user.uid;  
                     
        console.log(uid);

    } else {
       
    } */


    const articleLists = [
    {
        articleID: "art001",
        articleName: "รถไฟฟ้าสายสีชมพู และจุดเชื่อมต่อ (อัปเดต 22 พ.ย. 66)",
        writerName: "Soline",
        articleDate: new Date("2023-11-22T21:11:38"),
        articleContent: ["https://images.unsplash.com/photo-1507525428034-b723cf961d3e"],
        articleCategory: "AI Tool",
        level: 'Basic',
        likeCount: 2,
        bookmarkCount: 2,
        viewCount: 70
    },
    {
        articleID: "art002",
        articleName: "รวมคาเฟ่เปิดใหม่ ย่านลาดพร้าว – บรรยากาศสุดมินิมอล",
        writerName: "Arisa",
        articleDate: new Date("2024-02-15T14:25:00"),
        articleContent: ["https://images.unsplash.com/photo-1554118811-1e0d58224f24"],
        articleCategory: "AI Tool",
        level: 'Basic',
        likeCount: 18,
        bookmarkCount: 9,
        viewCount: 213
    },
    {
        articleID: "art003",
        articleName: "10 จุดเช็กอินริมทะเลหัวหิน ถ่ายรูปสวยทุกมุม ถ่ายรูปสวยทุกมุม ถ่ายรูปสวยทุกมุม",
        writerName: "Mintra",
        articleDate: new Date("2024-03-08T10:45:00"),
        articleContent: ["https://picsum.photos/id/1011/600/400"],
        articleCategory: "AI Tool",
        level: 'Basic',
        likeCount: 45,
        bookmarkCount: 20,
        viewCount: 512
    },
    {
        articleID: "art004",
        articleName: "AI สรุปข่าวรายวัน – รู้เรื่องทันใน 5 นาที",
        writerName: "Encraft Team",
        articleDate: new Date("2024-05-20T09:00:00"),
        articleContent: ["https://picsum.photos/id/1005/600/400"],
        articleCategory: "AI Tool",
        level: 'Basic',
        likeCount: 36,
        bookmarkCount: 15,
        viewCount: 380
    },
    {
        articleID: "art005",
        articleName: "รีวิวคีย์บอร์ด LOGA – ดีไซน์ไทย ใช้จริงสบายมือ",
        writerName: "Wirat",
        articleDate: new Date("2024-06-02T18:10:00"),
        articleContent: ["https://picsum.photos/id/1020/600/400"],
        articleCategory: "AI Tool",
        level: 'Intermediate',
        likeCount: 12,
        bookmarkCount: 5,
        viewCount: 187
    },
    {
        articleID: "art006",
        articleName: "เที่ยวญี่ปุ่นด้วยตัวเอง – แพลน 5 วัน 4 คืน โตเกียว-ฟูจิ",
        writerName: "Sora",
        articleDate: new Date("2024-07-12T11:40:00"),
        articleContent: ["https://picsum.photos/id/1003/600/400"],
        articleCategory: "AI Tool",
        level: 'Basic',     
        likeCount: 88,
        bookmarkCount: 35,
        viewCount: 950
    },
    {
        articleID: "art007",
        articleName: "AI Tools ที่ต้องลองในปี 2025 – ตัวช่วยเพิ่ม Productivity",
        writerName: "Encraft Team",
        articleDate: new Date("2024-12-10T08:30:00"),
        articleContent: [Test_Card_02],
        articleCategory: "AI Tool",
        level: 'Intermediate',
        likeCount: 67,
        bookmarkCount: 25,
        viewCount: 612
    },
    {
        articleID: "art008",
        articleName: "รวมเทคนิคใช้ ChatGPT + Canva สร้างโพสต์ไวภายใน 5 นาที",
        writerName: "Encraft Studio",
        articleDate: new Date("2025-02-05T20:00:00"),
        articleContent: ["https://images.unsplash.com/photo-1568084680786-a84f91d1153c"],
        articleCategory: "AI Tool",
        level: 'Basic',
        likeCount: 92,
        bookmarkCount: 40,
        viewCount: 830
    },
    {
        articleID: "art009",
        articleName: "Canva สร้างโพสต์ไวภายใน 5 นาที",
        writerName: "Encraft Studio",
        articleDate: new Date("2025-02-05T20:00:00"),
        articleContent: ["https://images.unsplash.com/photo-1554118811-1e0d58224f24"],
        articleCategory: "AI Tool",
        level: 'Basic',
        likeCount: 52,
        bookmarkCount: 40,
        viewCount: 70
    },
    ];

     const navigate = useNavigate();

    ////////////////// Create Article //////////////////////////////

    const categoryOption = ["การท่องเที่ยว"];
    const [categoryString, setCategoryString] = useState(categoryOption[0]);
    const [categoryType, setCategoryType] = useState("");

    const [subCategoryOption, setSubCategoryOption] = useState(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "ท่องเที่ยวอื่น ๆ"]);
    const [subCategoryString, setSubCategoryString] = useState(subCategoryOption[0]);
    const [subCategoryType, setSubCategoryType] = useState("");

    const [typeCategoryOption, setTypeCategoryOption] = useState(["กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พะเยา", "พังงา", "พัทยา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยโสธร", "ยะลา", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสาคร", "สมุทรสงคราม", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อำนาจเจริญ", "อุดรธานี", "อุตรดิตถ์", "อุทัยธานี", "อุบลราชธานี", "การท่องเที่ยงในประเทศไทยอื่น ๆ"]);
    const [typeCategoryString, setTypeCategoryString] = useState(typeCategoryOption[0]);
    const [typeCategoryType, setTypeCategoryType] = useState("");

    const [articleType, setArticleType] = useState(["ทั่วไป", "รีวิว", "คำถาม"]);
    const [articleTypeString, setArticleTypeString] = useState(articleType[0]); 


    ///////////////// Create Article ///////////////////////////////


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

   /*  const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [writerID, setWriterID] = useState("");

    const [articleLists, setArticleLists] = useState([]);
    const [currentCursor, setCurrentCursor] = useState("");

    useEffect(() => {
        const firsPageRef = firestore
            .collection("article")
            .orderBy("articleDate", "desc")
            .where("articleCategory", "==", "การท่องเที่ยว")
            .where("publicStatus", "==", "เผยแพร่")
            .where("status", "==", "public")
          
            .limit(8);
        firsPageRef.get().then((querySnapshot) => {
            let tempLists = [];
            querySnapshot.docs.forEach((doc) => {
                if (doc.exists) {

                    const currentArticle = {

                        articleID: doc.id,
                        articleID: doc.data().articleID,
                       
                        writerID: doc.data().writerID,
                        writerName: doc.data().writerName,
                        articletName: doc.data().articleName,
                        articleDate: doc.data().articleDate,

                        articleHeader: doc.data().articleHeader,
                        articleContent: doc.data().articleContent,
                        articleContentType: doc.data().articleContentType,
                        articleSection: doc.data().articleSection,

                        articleBadge: doc.data().articleBadge,

                        updateCount: doc.data().updateCount,
                        viewCount: doc.data().viewCount,

                        likeCount: doc.data().likeCount,
                        bookmarkCount: doc.data().bookmarkCount,



                    };
                    tempLists = [...tempLists, currentArticle];
                    setWriterID(doc.data().writerID);
                }
            });


            setArticleLists((prv) => tempLists);
            const currentLenght = querySnapshot.docs.length;
            const currentCursorFromFirstPage = querySnapshot.docs[currentLenght - 1];
            setCurrentCursor(currentCursorFromFirstPage);
        })
    }, []);

    const onMoreArticles = () => {
        const nextPageRef = firestore
            .collection("article")
            .orderBy("articleDate", "desc")
            .where("articleCategory", "==", "การท่องเที่ยว")
            .where("publicStatus", "==", "เผยแพร่")
            .where("status", "==", "public")
   
            .limit(8);
        nextPageRef.get().then((querySnapshot) => {
            const currentLenght = querySnapshot.docs.length;
            if (!currentCursor) {
                return;
            }
            const query = nextPageRef.startAfter(currentCursor);
            query.get().then((querySnapshot) => {
                let tempNewArray = [];
                querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                        tempNewArray = [
                            ...tempNewArray,
                            {
                                articleID: doc.id,
                                articleID: doc.data().articleID,

                                writerID: doc.data().writerID,
                                writerName: doc.data().writerName,
                                articletName: doc.data().articleName,
                                articleDate: doc.data().articleDate,

                                articleHeader: doc.data().articleHeader,
                                articleContent: doc.data().articleContent,
                                articleContentType: doc.data().articleContentType,
                                articleSection: doc.data().articleSection,

                                articleBadge: doc.data().articleBadge,

                                updateCount: doc.data().updateCount,
                                viewCount: doc.data().viewCount,

                                likeCount: doc.data().likeCount,
                                bookmarkCount: doc.data().bookmarkCount,

                            },
                        ];

                        setWriterID(doc.data().writerID);
                    }
                });


                setArticleLists([...articleLists, ...tempNewArray]);
                const currentCursorForNextPage = querySnapshot.docs[currentLenght -1];
                setCurrentCursor(currentCursorForNextPage);
            });
        });
    }; */


    ///////////////////////////////////////// Create Article //////////////////////////////////////////
    const articleID = "arid" + Math.random(999).toString();

    const [storeName, setStoreName] = useState("");


    const [articleName, setArticleName] = useState("");
  /*   const [articleDate, setArticleDate] = useState("");

    const [articleCategory, setArticleCategory] = useState("");
    const [articleSubCategory, setArticleSubCategory] = useState("");
    const [articleTypeCategory, setArticleTypeCategory] = useState("");

    const [articleHeader, setArticleHeader] = useState([""]);
    const [articleContent, setArticleContent] = useState([""]);
    const [articleContentType, setArticleContentType] = useState([""]);
    const [articleSection, setArticleSection] = useState([""]);

  
    const [ratingSum, setRatingSum] = useState(0);
    const [ratingCount, setRatingCount] = useState(0);

   


    const navigate = useNavigate();

    const [writerName, setWriterName] = useState("");
    const [writerDescription, setWriterDescription] = useState("");
    const [writerImg, setWriterImg] = useState("");

    

    const [dataWriter, setDataWriter] = useState([]);
    useEffect(() => {
    const userRef = firestore.collection("user");
    const query = userRef
    
        .where("uid", "==", uid);
            query
            .get()
            .then((querySnapshot) => {
                let tempDataArray =[];
                querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                        console.log(doc.data());
                        tempDataArray = [...tempDataArray,
                        {
                            uid: doc.id,

                            displayName: doc.data().displayName,
                            description: doc.data().description,
                            profileImg: doc.data().profileImg,
                            
                        },
                        
                    ];


                    setWriterName(doc.data().displayName);
                    setWriterDescription(doc.data().description);
                    setWriterImg(doc.data().profileImg);

                    

                    };

                    

                });


            setDataWriter((oldDataArray) => tempDataArray);

        },

            (err) => {
                console.log(err);
            }
            
        );

    }, [uid]); */











     ////////////////ADD ARTICLE NOT LOG IN
    const [showAddArticleNotlogin, setShowAddArticleNotlogin] = useState(false);
    const handleCloseAddArticleNotlogin = () => setShowAddArticleNotlogin(false);

    const [showMyArticleNotlogin, setShowMyArticleNotlogin] = useState(false);
    const handleCloseMyArticleNotlogin = () => setShowMyArticleNotlogin(false);

    /* const handleSubmit = (event) => {
        event.preventDefault();
      

        if (user == null) {
           
            setShowAddArticleNotlogin(true);
            setShow(false);

        } else {
            const obj = {

                writerID: uid,
                storeName: storeName,

                writerName: writerName,
                writerImg: writerImg,
                writerDescription: writerDescription,
    
                articleID: articleID,
                articleDate: new Date(),
                articleName: articleName,
    
                articleCategory: categoryString,
                articleSubCategory: subCategoryString,
                articleTypeCategory: typeCategoryString,
    
                articleHeader: [""],
                articleContent: [""],
                articleContentType: [""],
                articleSection: [""],

                articleRefText: [""],
                articleLinkRefText: [""],
    
                updateCount: 0,
                viewCount: 1,
    
                likeCount: 1,
                userIDLike: [""],
                profileUserImgLike: [""],
                descriptionUserLike: [""],
                displayNameUserLike: [""],
    
                bookmarkCount: 1,
                userIDBookmark: [""],
                profileUserImgBookmark: [""],
                descriptionUserBookmark: [""],
                displayNameUserBookmark: [""],
                
                articleType: articleTypeString,
    
                status: "inprogress",
                publicStatus: "กำลังดำเนินการ",
    
            };
    
            createArticleHandler(obj);

        }
        

 
        
    } */


    /* const createArticleHandler = (obj) => {
           
        const ref = firestore.collection("article");
        ref
            .doc(articleID)
            .set(obj)
            .then(() => {
                console.log("เพิ่มข้อมูลสำเร็จ");
                navigate("/CreateArticle/" + articleID)
            })
            .catch((err) => console.log(err));
    }; */
    ///////////////////////////////////////// Dynamic TypeCategory ////////////////////////////////////

    useEffect(() => {

        if (subCategoryString == "การท่องเที่ยวไทย") {

            setTypeCategoryOption(["กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พะเยา", "พังงา", "พัทยา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยโสธร", "ยะลา", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสาคร", "สมุทรสงคราม", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อำนาจเจริญ", "อุดรธานี", "อุตรดิตถ์", "อุทัยธานี", "อุบลราชธานี", "การท่องเที่ยวในประเทศไทยอื่น ๆ"]);
            setTypeCategoryString(typeCategoryOption[0]);
            
        } else if (subCategoryString == "การท่องเที่ยวเอเชีย") {

            setTypeCategoryOption(["ญี่ปุ่น", "เกาหลีใต้", "จีน", "สิงคโปร์", "เวียดนาม", "มาเลเซีย", "ฟิลิปปินส์", "อินโดนีเซีย", "รัสเซีย", "ออสเตรเลีย", "อินเดีย", "ปากีสถาน", "บังกลาเทศ", "อิหร่าน", "ตุรกี", "พม่า", "อิรัก", "ซาอุดีอาระเบีย", "อุซเบกิสถาน", "เนปาล", "อัฟกานิสถาน", "เยเมน", "เกาหลีเหนือ", "ไต้หวัน", "ศรีลังกา", "ซีเรีย", "คาซัคสถาน", "กัมพูชา", "อาเซอร์ไบจาน", "สหรัฐอาหรับเอมิเรตส์", "ทาจิกิสถาน", "อิสราเอล", "ฮ่องกง", "จอร์แดน", "ลาว",  "คีร์กีซสถาน", "สิงคโปร์", "เติร์กเมนิสถาน", "ปาเลสไตน์", "เลบานอน", "โอมาน", "คูเวต", "จอร์เจีย", "มองโกเลีย", "อาร์มีเนีย", "กาตาร์", "บาห์เรน", "ติมอร์-เลสเต", "ภูฏาน", "มาเก๊า", "บรูไน", "มัลดีฟส์"]);
            setTypeCategoryString(typeCategoryOption[0]);
            
        } else if (subCategoryString == "การท่องเที่ยวยุโรป") {

            setTypeCategoryOption(["รัสเซีย", "เยอรมนี", "ตุรกี", "ฝรั่งเศส", "สหราชอาณาจักร", "อิตาลี", "สเปน", "ยูเครน", "โปแลนด์", "โรมาเนีย", "เนเธอร์แลนด์", "เบลเยียม", "กรีซ", "เช็กเกีย", "โปรตุเกส", "สวีเดน", "ฮังการี", "อาเซอร์ไบจาน", "เบลารุส", "ออสเตรีย", "สวิตเซอร์แลนด์", "เซอร์เบีย", "บัลแกเรีย", "เดนมาร์ก", "ฟินแลนด์", "สโลวาเกีย", "นอร์เวย์", "ไอร์แลนด์","โครเอเชีย", "บอสเนียและเฮอร์เซโกวีนา", "จอร์เจีย", "มอลโดวา", "อาร์มีเนีย", "แอลเบเนีย", "ลิทัวเนีย", "มาซิโดเนียเหนือ", "สโลวีเนีย", "ลัตเวีย", "คอซอวอ", "เอสโตเนีย", "ไซปรัส", "มอนเตเนโกร", "ลักเซมเบิร์ก","มอลตา", "ไอซ์แลนด์", "เจอร์ซีย์ (UK)", "ไอล์ออฟแมน (UK)", "อันดอร์รา", "เกิร์นซีย์ (UK)", "หมู่เกาะแฟโร (Denmark)", "ลีชเทินชไตน์", "โมนาโก", "ยิบรอลตาร์ (UK)", "ซานมารีโน", "หมู่เกาะโอลันด์ (Finland)", "สฟาลบาร์ (Norway)", "นครรัฐวาติกัน"]);
            setTypeCategoryString(typeCategoryOption[0]);
            
        } else if (subCategoryString == "การท่องเที่ยวอเมริกา") {

            setTypeCategoryOption(["สหรัฐอเมริกา", "บราซิล", "เม็กซิโก", "โคลอมเบีย", "อาร์เจนตินา", "แคนาดา", "เปรู", "เวเนซุเอลา", "ชิลี", "เอกวาดอร์", "กัวเตมาลา", "คิวบา", "เฮติ", "โบลิเวีย", "สาธารณรัฐโดมินิกัน", "ฮอนดูรัส", "ปารากวัย", "นิการากัว", "เอลซัลวาดอร์", "คอสตาริกา", "ปานามา", "ปวยร์โตรีโก", "อุรุกวัย", "จาเมกา", "ตรินิแดดและโตเบโก", "กายอานา", "ซูรินาม", "กัวเดอลุป", "มาร์ตีนิก", "บาฮามาส", "เบลีซ", "บาร์เบโดส", "เฟรนช์เกียนา", "เซนต์ลูเชีย", "กูราเซา", "อารูบา", "เซนต์วินเซนต์และเกรนาดีนส์", "หมู่เกาะเวอร์จินของสหรัฐ", "กรีเนดา", "แอนทีกาและบาร์บิวดา", "ดอมินีกา", "เบอร์มิวดา", "หมู่เกาะเคย์แมน", "กรีนแลนด์", "หมู่เกาะเติกส์และเคคอส", "หมู่เกาะบริติชเวอร์จิน", "แองกวิลลา", "แซงปีแยร์และมีเกอลง", "มอนต์เซอร์รัต", "หมู่เกาะฟอล์กแลนด์"]);
            setTypeCategoryString(typeCategoryOption[0]);
            
        } else if (subCategoryString == "การท่องเที่ยวโอเชียเนีย") {

            setTypeCategoryOption(["ออสเตรเลีย", "ปาปัวนิวกินี", "นิวซีแลนด์", "ฟีจี", "หมู่เกาะโซโลมอน", "วานูวาตู", "นิวแคลิโดเนีย (ฝรั่งเศส)", "เฟรนช์พอลินีเชีย (ฝรั่งเศส)", "ซามัว", "กวม (สหรัฐ)", "คิริบาส", "ตองงา", "ไมโครนีเชีย", "หมู่เกาะมาร์แชลล์", "หมู่เกาะนอร์เทิร์นมาเรียนา (สหรัฐ)", "อเมริกันซามัว (สหรัฐ)", "ปาเลา", "หมู่เกาะคุก (นิวซีแลนด์)", "วอลิสและฟูตูนา (ฝรั่งเศส)", "ตูวาลู", "นาอูรู", "เกาะนอร์ฟอล์ก (ออสเตรเลีย)", "นีวเว (นิวซีแลนด์)", "โตเกเลา (นิวซีแลนด์)", "หมู่เกาะพิตแคร์น (สหราชอาณาจักร)"]);
            setTypeCategoryString(typeCategoryOption[0]);
            
        } else if (subCategoryString == "การท่องเที่ยวแอฟริกา") {

            setTypeCategoryOption(["ไนจีเรีย", "เอธิโอเปีย", "อียิปต์", "สาธารณรัฐประชาธิปไตยคองโก", "แอฟริกาใต้", "แทนซาเนีย", "เคนยา", "ซูดาน", "แอลจีเรีย", "ยูกันดา", "โมร็อกโก", "โมซัมบิก", "กานา", "แองโกลา", "โกตดิวัวร์", "มาดากัสการ์", "แคเมอรูน", "ไนเจอร์", "บูร์กินาฟาโซ", "มาลี", "มาลาวี", "แซมเบีย", "โซมาเลีย", "เซเนกัล", "ชาด", "ซิมบับเว", "ซูดานใต้", "รวันดา", "ตูนิเซีย", "กินี", "เบนิน", "บุรุนดี", "โตโก", "เอริเทรีย", "เซียร์ราลีโอน", "ลิเบีย", "สาธารณรัฐคองโก", "สาธารณรัฐแอฟริกากลาง", "ไลบีเรีย", "มอริเตเนีย", "นามิเบีย", "บอตสวานา", "แกมเบีย", "อิเควทอเรียลกินี", "เลโซโท", "กาบอง", "กินี-บิสเซา", "มอริเชียส", "เอสวาตีนี", "จิบูตี", "เรอูว์นียง", "คอโมโรส", "กาบูเวร์ดี", "มายอต", "เซาตูแมอีปริงซีป", "เซเชลส์", "เซนต์เฮเลนา"]);
            setTypeCategoryString(typeCategoryOption[0]);
            
        } else if (subCategoryString == "การท่องเที่ยวอื่น ๆ") {

            setTypeCategoryOption(["การท่องเที่ยวอื่น ๆ"]);
            setTypeCategoryString(typeCategoryOption[0]);
            
        }

    }, [subCategoryString]);

    ///////////////////////////////////////////////////////////////////////////////////////////////////

    

    return (
    
    <div>

    <>

        

        <br/>

        

        <h3><strong><BsRobot/> อัพเดตล่าสุด</strong></h3>
        <p>บทความล่าสุดเกี่ยวกับ AI, AI Tool, AI Prompt, AI Automation</p>

        <Link to={'/ArticleSubCategory'} state={"การท่องเที่ยวไทย"}><Button className="rounded-pill border-1" variant="outline-dark" style={{margin: 5, marginLeft: 0, marginRight: 5}}>ไทย</Button></Link>{' '}
        <Link to={'/ArticleSubCategory'} state={"การท่องเที่ยวเอเชีย"}><Button className="rounded-pill border-1" variant="outline-dark" style={{margin: 5, marginLeft: 0, marginRight: 5}}>เอเชีย</Button></Link>{' '}
        <Link to={'/ArticleSubCategory'} state={"การท่องเที่ยวยุโรป"}><Button className="rounded-pill border-1" variant="outline-dark" style={{margin: 5, marginLeft: 0, marginRight: 5}}>ยุโรป</Button></Link>{' '}
        <Link to={'/ArticleSubCategory'} state={"การท่องเที่ยวอเมริกา"}><Button className="rounded-pill border-1" variant="outline-dark" style={{margin: 5, marginLeft: 0, marginRight: 5}}>อเมริกา</Button></Link>{' '}
        <Link to={'/ArticleSubCategory'} state={"การท่องเที่ยวอื่น ๆ"}><Button className="rounded-pill border-1" variant="outline-dark" style={{margin: 5, marginLeft: 0, marginRight: 5}}>อื่น ๆ</Button></Link>{' '}

        <br/>
        <br/>
{/* 
        {(writerID == "") ? (
                <>
                    <br/>
                    <h4>ยังไม่มีบทความส่วนนี้</h4>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                </>
            ) : (
                <></>
            )} */}

            <Row xs={1} md={2} className="g-4">

                


            {articleLists.slice(0,2).map((item) => {
                            
                return (
                    <>

                    
                               
                    <div key={item.id}>



                                <div >
                                    <Link to={'/ReadArticle/'+ item.articleID} style={{textDecoration: 'none', color: "black"}}>
                                        <Card className="cardarticlehilight">

                                            {!!item.articleContent[0] ? (
                                                <Card.Img variant="top" class='cardarticledetailimghilight' src={item.articleContent[0]} />
                                            ) : (
                                                <Col style={{backgroundColor: '#FFFAFA'}}><div class='cardarticledetailnoimghilight'><strong>{(item.writerName)}</strong></div></Col>
                                            )}
                                            
                                            
                                            <Card.Body class='cardarticledetail'>
                                                <Card.Title>
                                                </Card.Title>

                                                <p class='articlename' style={{fontWeight: 'bolder'}}>{item.articleName}</p>
                                           
                                                {/* <p class='cardarticledetailnamedatetime'>{item.writerName} <br/> {(item.articleDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})} | {(item.articleDate).toDate().toLocaleTimeString()}  */}
                                                 <p class='cardarticledetailnamedatetime'>{item.writerName} 
                                                <br/>
                                             
                                                {/* <span class='cardarticledetaillikebookmark'><strong><FaRegHeart/> {item.likeCount}</strong> &nbsp;&nbsp;&nbsp;<strong><BsBookmark/> {item.bookmarkCount} &nbsp;&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong> <Badge style={{fontWeight: 'bold', marginTop: 5}} className="float-end rounded-pill" bg="light text-secondary">{item.articleCategory}</Badge></span></p> */}
                                                <span class='cardarticledetaillikebookmark'><strong><span style={{color: '#ff4b4b'}}><MdSignalCellular1Bar/></span> <span style={{color: 'dimgray', fontWeight: 'bolder'}}>{item.level}</span></strong> &nbsp;&nbsp;&nbsp;<strong><BsFiletypePdf/></strong> <Badge style={{fontWeight: 'bold', marginTop: 5}} className="float-end rounded-pill" bg="light text-secondary">{item.articleCategory}</Badge></span></p>

   
                                                    

                                            </Card.Body>
                                        </Card>
                                    </Link> 
                                </div>
                        

                    </div>

                    </>)
            })}

            </Row>

            <br/>


            <Row xs={2} md={4} className="g-4">


            {articleLists.slice(2,6).map((item) => {
                            
                return (
                    <>

                    
                               
                    <div key={item.id}>



                                <div >
                                    <Link to={'/ReadArticle/'+ item.articleID} style={{textDecoration: 'none', color: "black"}}>
                                        <Card className="cardarticle">

                                            {!!item.articleContent[0] ? (
                                                <Card.Img variant="top" class='cardarticledetailimg' src={item.articleContent[0]} />
                                            ) : (
                                                <Col style={{backgroundColor: '#FFFAFA'}}><div class='cardarticledetailnoimg'><strong>{(item.writerName)}</strong></div></Col>
                                            )}
                                            
                                            
                                            <Card.Body class='cardarticledetail d-flex flex-column justify-content-between'>
                                                <Card.Title>
                                                    
                                                </Card.Title>

                                              
                                                <p class='articlename' style={{fontWeight: 'bolder'}}>{item.articleName}</p>
                                                
                                           
                                                {/* <p class='cardarticledetailnamedatetime'>{item.writerName} <br/> {(item.articleDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})} | {(item.articleDate).toDate().toLocaleTimeString()}  */}
                                                 <p class='cardarticledetailnamedatetime'><BsClock/> 16 ตุลาคม 2568 | {item.writerName} 
                                                <br/>
                                                <br/>
                                             
                                                {/* <span class='cardarticledetaillikebookmark'><strong><FaRegHeart/> {item.likeCount}</strong> &nbsp;&nbsp;&nbsp;<strong><BsBookmark/> {item.bookmarkCount} &nbsp;&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong> <Badge style={{fontWeight: 'bold', marginTop: 5}} className="float-end rounded-pill" bg="light text-secondary">{item.articleCategory}</Badge></span></p> */}
                                               
                                                <span class='cardarticledetaillikebookmark'><strong><span style={{color: '#ff4b4b'}}><MdSignalCellular3Bar/></span> <span style={{color: 'dimgray', fontWeight: 'bolder'}}>{item.level}</span></strong> &nbsp;&nbsp;&nbsp;<strong><BsBookmark/> {item.bookmarkCount} &nbsp;&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong> <Badge style={{fontWeight: 'bold', marginTop: 5}} className="float-end rounded-pill" bg="light text-secondary">{item.articleCategory}</Badge></span></p>
                                                
   
                                                    

                                            </Card.Body>
                                        </Card>
                                    </Link> 
                                </div>
                        

                    </div>

                    </>)
            })}

            </Row>

            <br/>
            <button type="button" className="btn btn-lg btn-encraft">
               <BsChatSquareHeart/> อัพเดตล่าสุดทั้งหมด
            </button>
        
           {/*  <Modal
                show={show} 
                onHide={handleClose} 
                animation={false} 
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Form onSubmit={handleSubmit}>

                <Modal.Header closeButton>
                <Modal.Title>การท่องเที่ยว</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                
                    <Form.Group className="mb-3">
                    <Form.Label>ชื่อบทความ</Form.Label>

                    <Form.Control 
                        type="text"
                        className="rounded-0" 
                        style={{ paddingLeft: 10 }}
                        value={articleName}
                        onChange={(e) => {
                        setArticleName(e.target.value);
                        }}
                        placeholder={"*กรุณากรอกชื่อบทความ"}
                        required
                                            
                        />
                        <Form.Control.Feedback type="invalid">
                            ชื่อบทความ
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>หมวดหมู่</Form.Label>
              

                        <Form.Control
                            className="rounded-0"
                            type="text"
                            placeholder="การท่องเที่ยว"
                            aria-label="Disabled input example"
                            readOnly
                        />

                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>หมวดหมู่ย่อย</Form.Label>

                        <Form.Select className="rounded-0" aria-label="Default select example"
                            onChange={(e) => setSubCategoryString(e.target.value)}
                            defaultValue={subCategoryString}
                        >
                            {subCategoryOption.map((option, index) => (
                            <option key={index}>{option}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>ประเภทหมวดหมู่</Form.Label>

                        <Form.Select className="rounded-0" aria-label="Default select example"
                            onChange={(e) => setTypeCategoryString(e.target.value)}
                            defaultValue={typeCategoryString}
                        >
                            {typeCategoryOption.map((option, index) => (
                            <option key={index}>{option}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>ประเภทบทความ</Form.Label>
                                           
                            <Form.Select className="rounded-0" aria-label="Default select example"
                                onChange={(e) => setArticleTypeString(e.target.value)}
                                defaultValue={articleTypeString}
                            >
                            {articleType.map((option, index) => (
                                <option key={index}>{option}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                
                </Modal.Body>

                <Modal.Footer>

                    {user ? (

                    <Link to={'/MyArticle/'+ uid} style={{textDecoration: 'none', color: "black"}}>
                        <Button variant="secondary">
                            บทความของฉัน
                        </Button>
                    </Link>

                    ) : (

                    <Button variant="secondary" onClick={() => setShowMyArticleNotlogin(true)}>
                            บทความของฉัน
                    </Button>

                    )}

                    <Button variant="success" type="submit">
                        เขียนบทความใหม่
                    </Button>
                </Modal.Footer>

                </Form>

            </Modal>
            

            <Modal 
                show={showAddArticleNotlogin} 
                onHide={handleCloseAddArticleNotlogin} 
                animation={false} 
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                <Modal.Title>เข้าสู่ระบบ/สมัครสมาชิก</Modal.Title>
                </Modal.Header>
                <Modal.Body><Link to={"/LogIn"} style={{textDecoration: 'none'}}>เข้าสู่ระบบ</Link> หรือ <Link to={"/SignUp"} style={{textDecoration: 'none'}}>สมัครสมาชิก</Link> เพื่อเขียนบทความ</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddArticleNotlogin}>
                        ปิด
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal 
                show={showMyArticleNotlogin} 
                onHide={handleCloseMyArticleNotlogin} 
                animation={false} 
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                <Modal.Title>เข้าสู่ระบบ/สมัครสมาชิก</Modal.Title>
                </Modal.Header>
                <Modal.Body><Link to={"/LogIn"} style={{textDecoration: 'none'}}>เข้าสู่ระบบ</Link> หรือ <Link to={"/SignUp"} style={{textDecoration: 'none'}}>สมัครสมาชิก</Link> เพื่อใช้งานบทความของฉัน</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseMyArticleNotlogin}>
                        ปิด
                    </Button>
                </Modal.Footer>
            </Modal> */}

            <br/>
            <br/>
              

           {/*  {currentCursor ? (
                <Col className='float-end'>

                    <Button onClick={() => setShow(true)} className="rounded-0" variant="outline-primary">+ เขียน</Button>{' '} <Button variant="primary" className="rounded-0" onClick={onMoreArticles}>แสดงเพิ่มเติม</Button>
        
                </Col>
            ) : (
                <Col className='float-end'>

                    <Button onClick={() => setShow(true)} className="rounded-0" variant="outline-primary">+ เขียน</Button>{' '} <Button variant="outline-secondary" className="rounded-0" disabled>ไม่มีบทความเพิ่มเติม</Button>
        
                </Col>
            )} */}

        {/* <br/>
        <br/>
        <br/> */}

        

     


    
        

    </>

    </div>
    
    

  );
}

export default NewestArticle;